import { useParams } from "react-router-dom";
import { useSuggestedUserQuery } from "../../../store/api/userApi";
import SuggestedUser from "./suggested-user";
import { useAppSelector } from "../../../hooks/store-hooks";

const RightBar = () => {
  const { user_id } = useParams();
  const { isLoading, refetch: refetchSuggestedUsers } = useSuggestedUserQuery({
    user_id,
    limit: 4,
  });
  const { suggestedUser: suggestedMembers } = useAppSelector(
    (state: any) => state.user,
  );

  const filteredSuggestedMembers = suggestedMembers?.filter(
    (member: any) => member._id !== user_id,
  );
  return (
    <div className="xl:w-[383px] xl:block hidden">
      <div className="bg-white p-4 rounded-lg">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-lg">Suggested Members</h3>
        </div>
        <div className="mt-4">
          {isLoading ? (
            <p>Loading...</p>
          ) : filteredSuggestedMembers?.length === 0 ? (
            <div className="flex flex-col justify-center items-center text-black gap-y-3 px-4">
              <img
                src="/assets/noevents.png"
                alt="No events"
                className="h-[95px] w-[95px]"
              />
              <p className="text-[15px] font-semibold">No New Suggestions</p>
              <p className="text-center text-[#404040] text-[13px]">
                Check back soon as we regularly update recommendations.
              </p>
            </div>
          ) : (
            filteredSuggestedMembers?.map((member: any) => (
              <SuggestedUser
                key={member.id}
                member={member}
                refetchSuggestedUser={refetchSuggestedUsers}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default RightBar;
